import { RoleLevel } from "../types/Role/RoleLevel";
import api from "../utils/api";
import { ROLE_LEVELS_URL } from "../utils/endpoints";

export async function getRoleLevels(roleTypeId?: string) {
  try {
    const response = await api.get(
      roleTypeId
        ? `${ROLE_LEVELS_URL}?RoleTypeId=${roleTypeId}`
        : ROLE_LEVELS_URL,
    );
    const data: RoleLevel[] = response.data.result.map((option: RoleLevel) => ({
      id: option.id,
      name: option.name,
      code: option.code,
      isActive: option.isActive,
    }));

    return data;
  } catch (error) {
    throw error;
  }
}
